// extracted by mini-css-extract-plugin
export default {"wrapperTable":"TableNormalCampaign_wrapperTable__WyyuS","flexData":"TableNormalCampaign_flexData__8lbb8"};